export interface DACIRole {
  id: string;
  name: string;
}

export interface DriverRole {
  id: string;
  name: string;
}

export const DACI_ROLES: DACIRole[] = [
  { id: 'driver', name: 'Driver' },
  { id: 'approver', name: 'Approver' },
  { id: 'contributor', name: 'Contributor' },
  { id: 'informed', name: 'Informed' }
];

export const DRIVER_ROLES: DriverRole[] = [
  { id: 'pmm', name: 'Prod Mrkt Manager' },
  { id: 'pm', name: 'Product Manager' },
  { id: 'pgm', name: 'Program Manager' },
  { id: 'marketing_pgm', name: 'Marketing PgM' },
  { id: 'e2e_pgm', name: 'E2E PgM' },
  { id: 'eng_manager_lead', name: 'Eng Manager/Lead' },
  { id: 'designer', name: 'Designer' },
  { id: 'e2e_journey_lead', name: 'E2E Journey Lead' },
  { id: 'gtm_lead', name: 'GTM Lead' },
  { id: 'comms_lead', name: 'Comms Lead' }
];
